// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18NqE","newExpiryDate":"styles_newExpiryDate__3QNPq","footer":"styles_footer__3wyU-"};